// Imports ------------------------------------------------------------------->

import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {Toast} from "../flipp-toast/Toast";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

interface ToastContainerProps extends JSX.HTMLProps {
	global?: boolean;
}

@element("flipp-toast-container")
export class ToastContainer extends Component<ToastContainerProps, {}> {

	@attr global: boolean;

	refs: {
		toast: Toast
	};

	onAttach() {
		const target = (this.global ? window : this) as EventTarget;
		target.addEventListener("flipp-toast", this.handleToast_);
	}

	onDetach() {
		const target = (this.global ? window : this) as EventTarget;
		target.removeEventListener("flipp-toast", this.handleToast_);
	}

	render() {
		return <template>
			<Toast ref="toast"/>
			<div class="toastable-content">
				<content />
			</div>
		</template>;
	}

	private handleToast_ = (e: CustomEvent) => {
		e.stopPropagation();
		e.preventDefault();
		if (e.detail.level) {
			this.refs.toast.level = e.detail.level;
		}
		if (e.detail.closeable) {
			this.refs.toast.closeable = e.detail.closeable;
		}
		this.refs.toast.message = e.detail.message;
	}
}
